import React, { FC } from "react";
import Icon from "newComponents/Shared/_Atoms/Icons/Icon/Icon";

interface IProps {
  value: string | number;
  className: PillClassName;
  onClick?: () => void;
  icon?: IconType;
  iconColor?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
}

const Pill: FC<IProps> = ({ value, className, onClick, icon, style, iconColor, disabled }) => {
  return (
    <div
      className={`pill ${className || ""}${disabled ? " disabled" : ""}`}
      onClick={onClick}
      style={style}
    >
      {icon && <Icon icon={icon} style={{ height: 12, color: iconColor }} />} {value}
    </div>
  );
};

export default Pill;
